import { useEffect } from 'react';
import { useGroupedQueuesStore, visibleQueuesSelector } from '..';
import { useKanbanEventStore } from '../Kanban';
import { GraphneEventSource } from '../eventSource/GraphneEventSource';
import { KanbanFilter, useKanbanFilterStore } from './useKanbanFilterStore';

let kanbanEventSource: GraphneEventSource | null = null;

export const useKanbanEventSource = () => {
  const hasVisibleQueues = useGroupedQueuesStore((state) => !!visibleQueuesSelector(state).length);
  const visibleQueues = useGroupedQueuesStore(visibleQueuesSelector);
  const setData = useKanbanEventStore((state) => state.setData);
  const setIsKanbanLoading = useKanbanEventStore((state) => state.setIsKanbanLoading);
  const { from, to } = useKanbanFilterStore((state) => state.kanbanDateRange);
  const kanbanFilters = useKanbanFilterStore((state) => state.kanbanFilters);

  useEffect(() => {
    if (hasVisibleQueues) {
      if (kanbanEventSource) {
        kanbanEventSource.close();
      }

      const queueIds = visibleQueues
        .map((queue) => queue.id?.toString())
        .filter((id): id is string => id !== undefined);

      kanbanEventSource = new GraphneEventSource({
        source: 'kanban',
        from,
        to,
        priority: kanbanFilters.includes(KanbanFilter.PRIORITY),
        requiresAcceptance: kanbanFilters.includes(KanbanFilter.TO_ACCEPT),
        onlyQueuesWithTasks: !kanbanFilters.includes(KanbanFilter.SHOW_WITHOUT_TASKS),
        isBehindSchedule: kanbanFilters.includes(KanbanFilter.DELAYED),
        queues: queueIds,
        onUpdate: (data) => {
          setData(data);
          setIsKanbanLoading(false);
        },
      });

      return () => {
        kanbanEventSource?.close();
      };
    }

    return () => {
      if (kanbanEventSource) {
        kanbanEventSource.close();
      }
    };
  }, [hasVisibleQueues, setData, visibleQueues.length, from, to, kanbanFilters]);
  // Only depend on queue count, not the contents

  return {};
};
